<template>
  <v-col
    :class="{
      'get-lower': !$vuetify.breakpoint.mdAndUp,
      'pa-0': true,
      fullScreen: true,
      fullScreenMobile: this.$vuetify.breakpoint.mdAndDown
    }"
    cols="12"
  >
    <DialogForMassOperators
      :dialog.sync="dialogDelete"
      :loading.sync="loading"
      :head-text="$t('tariffs.delete-title')"
      :content-text="$t('tariffs.delete-dialog')"
      :confirm-button="{
        text: $t('tariffs.delete'),
        icon: 'mdi-trash-can-outline'
      }"
      :selected.sync="selected"
      v-on:update:selected="updateSelected"
      permission="tariff.delete"
      dispatch="projectMeteringStore/tariffStore/deleteList"
      :on-success="updateList"
      permissions-item-key="_project"
    ></DialogForMassOperators>
    <v-toolbar dense flat>
      <v-toolbar-title>{{ $t("tariffs.tariffs") }}</v-toolbar-title>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          v-for="item in menu"
          :key="item.title"
          :to="item.to"
          text
          color="primary"
          :disabled="item.disabled"
          v-on:click="item.onClick()"
          ><v-icon left>{{ item.icon }}</v-icon> {{ item.title }}</v-btn
        >
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>
    <v-container>
      <v-row>
        <v-col cols="3">
          <v-sheet class="pa-2 ma-2">
            <v-autocomplete
              v-if="tariffPlans.length"
              :items="tariffPlans"
              item-text="text"
              item-value="value"
              :label="$t('tariffs.tariff-plan')"
              v-model="filteredTariffPlan"
              @change="filterList"
            ></v-autocomplete
          ></v-sheet>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-sheet class="pa-2 ma-2">
            <v-btn block @click="resetFilter">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>

    <CommonTable
      list-getter="projectMeteringStore/tariffStore/getList"
      :headers="headers"
      :slots="slots"
      :actions="actions"
      resource="tariffs"
      createItemDispatch="projectMeteringStore/tariffStore/create"
      updateItemDispatch="projectMeteringStore/tariffStore/update"
      deleteItemDispatch="projectMeteringStore/tariffStore/delete"
      @updated="updateList"
      :loading.sync="loading"
      :static-dispatch-params="{ project_id: this.project_id }"
      :can-add="canAdd"
      :can-edit="canEdit"
      :can-delete="canDelete"
      :selected.sync="selected"
      v-on:update:selected="updateSelected"
      show-select
    ></CommonTable>
    <Paginator
      page-getter="projectMeteringStore/tariffStore/getPage"
    ></Paginator>
  </v-col>
</template>

<script>
import Paginator from "../../../components/common/tables/Paginator";
import CommonTable from "../../../components/common/tables/CommonTable";
import { rules } from "../../../components/mixins/rules";
import { projectTitle } from "../../../components/mixins/projects/projectTitle";
import { projectPermissions } from "../../../components/mixins/projects/projectPermissions";
import { permissions } from "../../../components/mixins/permissions";
import DialogForMassOperators from "../../../components/common/dialogs/DialogForMassOperators";
export default {
  name: "Tariffs",
  props: ["project_id"],
  mixins: [rules, projectTitle, projectPermissions, permissions],
  data: function() {
    return {
      headers: [
        {
          text: this.$t("tariffs.tariff-plan"),
          align: "left",
          value: "_tariff_plan_name"
        },
        {
          text: this.$t("tariffs.tariffable"),
          value: "_tariffable",
          sortable: false
        },
        {
          text: this.$t("tariffs.timeframe"),
          value: "_timeframe_name",
          sortable: false
        },
        {
          text: this.$t("tariffs.valid-from"),
          value: "valid_from",
          sortable: true
        },
        {
          text: this.$t("tariffs.value"),
          align: "left",
          value: "value"
        },
        {
          text: this.$t("tariffs.action"),
          value: "action",
          align: "right",
          sortable: false
        }
      ],
      actions: [],
      filteredTimeframes: [],
      tariffPlanId: null,
      filteredTariffPlan: null,
      loading: false,
      selected: [],
      dialogDeleteOne: false,
      dialogDelete: false
    };
  },
  components: { Paginator, CommonTable, DialogForMassOperators },
  computed: {
    slots() {
      let rules = this.rules;
      return [
        {
          name: "_tariff_plan_name",
          title: "tariff-plan",
          to: "tariff-plan",
          type: "link",
          linkParams: {
            id: "tariff_plan_id"
          },
          form: {
            type: "autocomplete",
            name: "tariff_plan_id",
            rules: [rules.required],
            items: this.tariffPlans,
            visible: true,
            change: this.getPlanData
          }
        },
        {
          name: "_tariffable",
          title: "tariffable",
          form: {
            name: "_tariffable_name",
            type: "tariffable",
            rules: [rules.required],
            visible: true
          }
        },
        {
          name: "_timeframe_name",
          title: "timeframe",
          form: {
            type: "combobox",
            name: "timeframe_id",
            items: this.timeframes,
            visible: true
          }
        },
        {
          name: "valid_from",
          title: "valid-from",
          type: "date",
          dateFormat: "short",
          form: {
            type: "date",
            rules: [rules.required],
            visible: true
          }
        },
        {
          name: "value",
          title: "value",
          type: "number",
          number_format: "decimal",
          form: {
            type: "text",
            input_type: "number",
            rules: [rules.required],
            visible: true
          }
        }
      ];
    },
    menu() {
      let vm = this;
      return [
        {
          title: this.$t("tariffs.delete"),
          to: null,
          onClick: function() {
            vm.dialogDelete = true;
          },
          disabled: !this.isSomeSelectedCanBeDelete,
          icon: "mdi-trash-can-outline"
        }
      ];
    },
    isSomeSelectedCanBeDelete() {
      return !!this.selected.find(i =>
        this.hasPermissions(i._project, "tariff.delete")
      );
    },
    getParams() {
      return ` ${this.$route.query.page}
                ${this.$route.query.limit_items}
                ${this.$route.query.orders}
                ${this.$route.query.search}
                `;
    },
    tariffPlans() {
      const tariffPlanObject = this.$store.getters[
        "projectMeteringStore/tariffPlanStore/getList"
      ];

      if (tariffPlanObject) {
        const tariffPlansArray = Object.values(tariffPlanObject);
        const mappedTariffPlans = tariffPlansArray.map(i => {
          return { text: i.name, value: i.id };
        });
        return mappedTariffPlans;
      } else {
        return [];
      }
    },
    modifiers() {
      return this.$store.getters["tariffPlanModifiersStore/getList"];
    },
    tariffs() {
      let project = this.$store.getters["projectStore/getCurrentItem"];
      return (
        this.$store.getters["projectMeteringStore/tariffStore/getList"] || []
      ).map(i => {
        let period = i["_tariff_periods"] && i["_tariff_periods"][0];
        if (!period) {
          return i;
        } else {
          return {
            ...i,
            price: period.price_per_unit,
            decorator: `${project.currency} ${this.$t(
              "tariffs.since"
            )} ${this.$dateTime(new Date(period.valid_from), "short")} `
          };
        }
      });
    },
    timeframes() {
      if (this.tariffPlanId) {
        return this.filteredTimeframes
          .filter(
            timeframe => timeframe._tariff_plan.id == this.tariffPlanId.value
          )
          .map(i => {
            return { text: i.name, value: i.id };
          });
      } else {
        return this.filteredTimeframes.map(i => {
          return { text: i.name, value: i.id };
        });
      }
    },
    canAdd: {
      get() {
        return this.hasCurrentProjectPermissions("tariff.create");
      }
    },
    canEdit: {
      get() {
        return this.hasCurrentProjectPermissions("tariff.update");
      }
    },
    canDelete: {
      get() {
        return this.hasCurrentProjectPermissions("tariff.delete");
      }
    }
  },

  watch: {
    getParams: function() {
      this.updateList();
    },
    tariffPlanId: function(newVal) {
      this.getPlanData(newVal);
    }
  },
  methods: {
    getArgumentForTitle() {
      return { chain: [this.$t("tariffs.tariffs")] };
    },
    updateList() {
      this.loading = true;
      let params = this.formingParams();
      this.$store.dispatch("projectMeteringStore/tariffStore/getList", {
        params,
        onSuccess: () => {
          this.loading = false;
          this.$root.$emit("updateTariffPlanId", null);
        }
      });
    },
    resetFilter() {
      this.filteredTariffPlan = null;
      this.filterList();
    },
    formingParams() {
      return {
        project_id: this.project_id,
        page: this.$route.query.page,
        limit: this.$route.query.limit_items,
        orders: "valid_from:desc",
        filters: {
          name: this.$route.query.search,
          tariff_plan_id: this.filteredTariffPlan
        }
      };
    },
    updateSelected(val) {
      this.$set(this.$data, "selected", val);
    },
    getPlanData(tariff_plan_id) {
      if (tariff_plan_id) {
        this.$root.$emit("updateTariffPlanId", tariff_plan_id);
      }

      this.tariffPlanId = null;
    },
    filterList() {
      this.$store.dispatch("projectMeteringStore/tariffStore/getList", {
        params: {
          filters: {
            tariffPlan: this.filteredTariffPlan
          },
          project_id: this.project_id
        }
      });
    }
  },
  mounted() {
    this.updateList();
    this.$store.dispatch("projectMeteringStore/tariffPlanStore/getList", {
      params: { limit: -1, project_id: this.project_id }
    });
    this.$store.dispatch("tariffPlanTimeframesStore/getList", {
      params: {
        project_id: this.project_id
      },
      onSuccess: data => {
        this.filteredTimeframes = Array.isArray(data.list) ? data.list : [];
      }
    });
    this.$store.dispatch("tariffPlanModifiersStore/getList", {
      params: {
        project_id: this.project_id
      }
    });
    this.$store.dispatch("tariffPlanComponentStore/getList", {
      params: {
        project_id: this.project_id
      }
    });
  }
};
</script>

<style scoped>
.fullScreen {
  height: calc(100vh - 48px - 24px);
  display: flex;
  flex-direction: column;
}
.fullScreen::v-deep > * {
  flex: 0 0 auto;
}
.fullScreenMobile {
  height: auto;
  display: flex;
  flex-direction: column;
}
</style>
